import React from "react";

interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ title, children, className, onClick }, ref) => (
    <div 
      ref={ref}
      className={`bg-white rounded-2xl shadow-md border border-border p-4 ${className || ""} ${
        onClick ? "cursor-pointer hover:shadow-lg transition-shadow duration-200" : ""
      }`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      } : undefined}
    >
      {title && <h3 className="text-sm font-semibold text-gray-700 mb-3">{title}</h3>}
      {children}
    </div>
  )
);

Card.displayName = "Card";